






































import { Component, Vue } from 'vue-property-decorator';
import FooterItem from './FooterItem.vue';

@Component({
  components: {
    FooterItem
  }
})
export default class Footer extends Vue {
  private items = [
        { label: "فروشگاه ها", link: "/shops/page/1", outside: true, target: '_self' },
        // { label: "تعرفه ها", link: "/prices", outside: false },
        { label: "برای توسعه دهندگان", link: "/developers", outside: false, target: '_blank' },
        { label: "پشتیبانی", link: "/support", outside: false, target: '_blank' },
        { label: "مستندات", link: "/docs", outside: true, target: '_blank' },
        { label: "درباره ما", link: "/about-us", outside: false, target: '_self' },
        // {label: "تماس با ما", link: "/contact-us"},
  ]
}
